import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

/**
 *
 * @param {string} key
 * @param {string} localStorageKey
 * @param {string | undefined} defaultValue
 * @returns {[string, (newValue: string) => void]}
 */
function useSyncedState(key, localStorageKey, defaultValue) {
  const location = useLocation()
  const history = useHistory()
  const [value, setValue] = useState(() => {
    // Try to get the value from the URL params
    const params = new URLSearchParams(location.search)
    const paramValue = params.get(key)

    console.log(paramValue)

    if (paramValue !== null) {
      localStorage.setItem(localStorageKey, paramValue)
      return paramValue
    } else {
      // If not in URL, try localStorage or use default
      const paramFromLocal = localStorage.getItem(localStorageKey) || defaultValue
      params.set(key, paramFromLocal)
      history.push({ search: params.toString() })
      return paramFromLocal
    }
  })

  // Update local state and localStorage when URL params change
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const paramValue = params.get(key)

    if (paramValue !== null) {
      setValue(paramValue)
      localStorage.setItem(localStorageKey, paramValue)
    }
  }, [location.search, key, localStorageKey])

  // Function to update both local state and URL params
  const setSyncedValue = newValue => {
    setValue(newValue)

    // Update localStorage
    localStorage.setItem(localStorageKey, newValue)

    // Update URL params
    const params = new URLSearchParams(location.search)
    params.set(key, newValue)
    history.push({ search: params.toString() })
  }

  return [value, setSyncedValue]
}

export default useSyncedState
